import { memo } from 'react';
import classes from './HeaderCollapse.module.less';

function HeaderCollapse({ name, isActive }) {
  return <div className={`${isActive ? classes.headerActiveName : classes.headerInactiveName}`}>{name}</div>;
}
export default memo(HeaderCollapse);
